/**
 * Состояние приложения для поиска словарей
 * Управляет текущим языком и текстами интерфейса
 */

// Определяем текущий язык из URL
var currentLang = window.location.pathname.split('/')[1] || 'en';
if (!['en', 'ru', 'de', 'fr'].includes(currentLang)) {
  currentLang = 'en';
}

// Получаем тексты из data-атрибутов (начальное значение)
// Используем функцию для ленивой инициализации, если body еще не готов
var getInitialNothingFoundText = function() {
  if (document.body) {
    return document.body.getAttribute('data-nothing-found') || 'Nothing found';
  }
  return 'Nothing found';
};

var nothingFoundText = getInitialNothingFoundText();

// Экспортируем глобально для совместимости
window.SEARCH_STATE = {
  getCurrentLang: function() { return currentLang; },
  setCurrentLang: function(lang) { currentLang = lang; },
  getNothingFoundText: function() { 
    // Если на момент инициализации body был null, пробуем получить сейчас
    if (nothingFoundText === 'Nothing found') {
      nothingFoundText = getInitialNothingFoundText();
    }
    return nothingFoundText; 
  },
  setNothingFoundText: function(text) { nothingFoundText = text; }
};

